/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import 'react-pro-sidebar/dist/css/styles.css';

const Layout = ({ children }) => (
  <div className="d-flex bg-gray0 map">
    <div className="dashboard w-100">
      <main>{children}</main>
    </div>
  </div>
);

export default Layout;
